/**
 * 将微服务前端入口 URL 解析为在当前页面下可安全加载的地址：
 * - HTTPS 页面强制升级 http -> https（大小写不敏感）
 * - 在 https://www.ihoms.cn 下，将 *.ihoms.cn 子域嵌入改为同域 routePath，避免混合内容与跨站 cookie 问题
 */

export interface SecureUrlServiceFields {
  url?: string;
  serviceUrl?: string;
  routePath?: string;
  name?: string;
}

function normalizeScheme(url: string, pageIsHttps: boolean): string {
  const t = url.trim();
  if (!t) return t;
  if (/^https:\/\//i.test(t)) return t;
  if (/^http:\/\//i.test(t) && pageIsHttps) {
    return t.replace(/^http:\/\//i, "https://");
  }
  if (/^https?:\/\//i.test(t)) return t;
  const rest = t.replace(/^\/\//, "");
  return `${pageIsHttps ? "https" : "http"}://${rest}`;
}

/**
 * @param serviceName 路由选中的服务名（如 msadmin、msreport）
 */
export function resolveSecureMicroserviceUrl(
  serviceName: string,
  service?: SecureUrlServiceFields,
): string | undefined {
  const raw = service?.url || service?.serviceUrl;
  if (!raw) return undefined;

  if (typeof window === "undefined") {
    return raw;
  }

  const pageIsHttps = window.location.protocol === "https:";
  let resolved = normalizeScheme(raw, pageIsHttps);

  // 默认保留各微服务独立域名，避免 iframe 误加载到 msLogin 壳（形成“多级嵌套”）。
  // 仅做 http -> https 归一化，不再自动改写为 www.ihoms.cn/<routePath>。

  return resolved;
}
